import type { ChargeCategory, TaxClass } from "@common/client"
import { TaxClassSchema } from "@common/client/schemas.gen"

export const TAX_CLASSES = TaxClassSchema.enum

export const TAX_CLASS_LABELS: Record<TaxClass, string> = {
  labour: "Labor",
  flat_rate_labour: "Flat-rate labor",
  component_workscopes: "Component workscopes",
  parts: "Parts",
  services: "Outside services",
  misc: "Misc charges",
  freight: "Freight",
  insurance: "Insurance",
}

export const TAX_CLASS_DESCRIPTIONS: Record<TaxClass, string> = {
  labour: "Technician time billed as hours × a rate",
  flat_rate_labour:
    "One price for a defined job on an aircraft, materials included or not",
  component_workscopes:
    "Test, repair and overhaul prices quoted per workscope on a component",
  parts: "Parts and materials sold to the customer",
  services: "Work bought from a vendor and billed on",
  misc: "Fees, discounts and fixed amounts that fit no other class",
  freight: "Shipping and handling",
  insurance: "Insurance passed through to the customer",
}

export const TAX_CLASS_CATEGORIES: Record<TaxClass, ChargeCategory> = {
  labour: "labour",
  flat_rate_labour: "labour",
  component_workscopes: "labour",
  parts: "parts",
  services: "services",
  misc: "misc",
  freight: "misc",
  insurance: "misc",
}

export const CHARGE_CATEGORY_LABELS: Record<ChargeCategory, string> = {
  labour: "Labor",
  parts: "Parts",
  services: "Outside services",
  misc: "Other charges",
}
